var map = {
	"./address_image.svg": 129,
	"./animated_logo.svg": 130,
	"./blogs_image.svg": 131,
	"./cloud_infrastructure.svg": 132,
	"./contactMail.png": 133,
	"./data_science.svg": 134,
	"./developerActivity.svg": 135,
	"./education.svg": 136,
	"./experience.svg": 137,
	"./fc21.png": 138,
	"./feelingProud.svg": 139,
	"./freecopy_logo.png": 140,
	"./fullstack.svg": 141,
	"./github_logo.png": 142,
	"./googleAssistant.svg": 143,
	"./google_logo.png": 144,
	"./harish_pic.jpg": 145,
	"./java.png": 146,
	"./java_logo.png": 147,
	"./jsFramework.svg": 148,
	"./logo.png": 149,
	"./manOnTable.svg": 150,
	"./mysirg_logo.png": 151,
	"./novanector.png": 152,
	"./p1.svg": 153,
	"./patil_infotech.png": 154,
	"./programmer.svg": 155,
	"./projects_image.svg": 156,
	"./s2.svg": 157,
	"./s3.svg": 158,
	"./s4.svg": 159,
	"./saayaHealthLogo.png": 160,
	"./sppu_logo.png": 161,
	"./talksCardBack.svg": 162,
	"./talksCardBackAlt.svg": 163,
	"./tcsion_logo.png": 164,
	"./ui_ux_design.svg": 165,
	"./vcs.svg": 166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;